var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMustard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "mustard",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Moutarde") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moutarde",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8338822,54.1626919 L38.3240682,54.1626919 C37.3850534,49.0515537 34.890035,35.3148744 34.396608,30.9248777 C34.9127245,29.9618067 38.2554531,27.0526377 47.4359288,26.6879664 L47.4359288,33.8121774 L40.8278342,33.8121774 C40.8278342,35.161789 39.8207511,36.273845 38.5176118,36.4449726 L40.1613661,48.8648442 L59.4621523,48.8648442 L61.411804,36.4354047 C60.1395551,36.2374872 59.165276,35.140193 59.165276,33.8121774 L52.468884,33.8121774 L52.468884,26.7459202 C61.136797,27.2926537 64.8198673,30.0572117 65.5699856,30.9959531 C64.8390029,35.635807 62.6619101,49.0641286 61.8338822,54.1626919 Z M61.9197194,26.1363123 L65.3020862,26.1363123 C66.101684,26.1363123 66.7495632,25.4878864 66.7495632,24.688562 L66.7495632,23.4477503 C66.7495632,22.6484259 66.101684,22 65.3020862,22 L34.2798804,22 C33.4802827,22 32.8321301,22.6484259 32.8321301,23.4477503 L32.8321301,24.688562 C32.8321301,25.4878864 33.4802827,26.1363123 34.2798804,26.1363123 L37.3309268,26.1363123 C33.2700637,27.7335943 31.9065103,29.9257222 32.0049223,30.8928938 C32.5278729,36.0300018 36.3478999,56.5377022 36.3478999,56.5377022 L63.8543359,56.5377022 C63.8543359,56.5377022 67.1872233,36.0300018 67.9909216,30.8928938 C68.1456472,29.9011192 66.3307653,27.7237531 61.9197194,26.1363123 L61.9197194,26.1363123 Z",
    id: "Fill-1",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("text", {
    id: "moutarde",
    xmlSpace: "preserve",
    x: 9,
    y: 97,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "moutarde"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustard);
export default __webpack_public_path__ + "static/media/mustard.b090bdbb8785db139be470439450bbb5.svg";
export { ForwardRef as ReactComponent };